import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/sylvanus/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { sylvanusBaseQuery } from './baseQuery';

const SYLVANUS_API_REDUCER_PATH = 'api/sylvanus' as const;

export const sylvanusApiRoot = createApi({
  reducerPath: SYLVANUS_API_REDUCER_PATH,
  baseQuery: sylvanusBaseQuery,
  keepUnusedDataFor: 5 * 60,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
